export default "__VITE_ASSET__Dq1qxg_W__"